import { render, staticRenderFns } from "./ListaNcm.vue?vue&type=template&id=cdbefa4e&scoped=true&"
import script from "./ListaNcm.vue?vue&type=script&lang=js&"
export * from "./ListaNcm.vue?vue&type=script&lang=js&"
import style0 from "./ListaNcm.vue?vue&type=style&index=0&id=cdbefa4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdbefa4e",
  null
  
)

export default component.exports